import { Colors } from '../Colors';

export default {
    defaultProps: {
        size: 'md',
    },
    styles: {
        label: {
            color: Colors.text,
        }
    }
};
